import React from 'react';

const Center = ({ children, className }) => {
  return (
    <div className={`d-flex justify-content-center align-items-center ${className}`}>
      {children}
    </div>
  );
};


export default Center;